import Validate from "./Validate.js";
import initCaptcha from '../components/Captcha/index.js';

class Form {
    constructor(form) {
        this.formDom = form;
        this.$form = $(form);
        this.$btn = this.$form.find(".js-submit");
        this.validateObj = "";

        // this.checkFilled();
        this.popLabels();
        this.drawPriceInInput();
        this.validate();
        this.initCaptcha();
        this.bindSubmit();
        this.bindClose();
        // this.disableAutoFill();
        this.disableIEautocomplete();
        this.fileUpload();
        this.filterPhone();
        // this.spamCheck();
    }

    async initCaptcha() {
        this.executeCaptcha = await initCaptcha(this.formDom);
    }

    // checkFilled() {
    //     this.$form.find(".js-input").on("input", function (e) {
    //         if (e.target.value.length) {
    //             $(this).parents(".js-input-wrap").addClass("_filled");
    //         } else {
    //             $(this).parents(".js-input-wrap").removeClass("_filled");
    //         }
    //     });
    // }

    // Валидация
    validate() {
        // new Validate(this.$form);
        this.validateObj = new Validate(this.$form);
    }

    // Событие отправки
    bindSubmit() {
        this.$form.on("submit", (e) => {
            e.preventDefault();

            // Блокируем кнопку сабмита
            this.$btn.attr("disabled", true);

            if (!this.validateObj.validateAllFields()) {
                e.preventDefault();

                const $firstError = this.$form.find('._error').first();
                const errorBox = $firstError[0].getBoundingClientRect();
                const isFirstErrorNotVisible = errorBox.top >= window.innerHeight || errorBox.bottom <= 0;

                if (isFirstErrorNotVisible) {
                    $("html, body").animate({scrollTop: $firstError.offset().top - 150}, 500);
                }

                this.$btn.removeAttr("disabled");
            } else {
                // Запускаем проверку капчи
                this.executeCaptcha({
                    onClose: () => {
                        // Посде закрытия формы капчи разблокируем кнопку
                        this.$btn.removeAttr('disabled');
                    },
                }).then(() => {
                    // Какпча пройдена
                    this.sendForm();
                }).catch((error) => {
                    this.$form
                        .removeClass("_form-success")
                        .addClass("_form-error _form-message");
                    this.$form.find(".js-error-message").addClass("_active");
                    this.$form.find(".js-error-message").text(error.message);
                }).finally(() => {
                    setTimeout(() => {
                        this.$btn.removeAttr('disabled');
                    }, 1000);
                });
            }
        });
    }

    // Отправка
    sendForm() {
        this.validate();

        this.$form.ajaxSubmit({
            url: this.$form.attr("action"),
            // dataType: "json",
            // data: this.$form.serialize(),
            type: this.$form.attr("method") || "GET",
            cache: false,
            success: (response) => {
                if (!response.success) {
                    // Ошибка на сервере
                    this.$form
                        .removeClass("_form-success")
                        .addClass("_form-error _form-message");
                    this.$form.find(".js-error-message").addClass("_active");
                    this.$form.find(".js-error-message").text("");
                    this.$form
                        .find(".js-error-message")
                        .prepend(response.message);

                    // Разблокируем кнопку
                    this.$btn.removeAttr("disabled");
                } else {
                    // Успех!
                    this.resetForm();

                    this.$form.find(".js-input-wrap").removeClass("_filled");
                    this.$form
                        .removeClass("_form-error")
                        .addClass("_form-success _form-message");
                    this.$form.find(".js-error-message").removeClass("_active");
                    this.$form.find(".js-error-message").text("");
                    this.$btn.removeAttr("disabled");

                    if (this.$form.parents(".js-form-feedback-wrap").length) {
                        const $formFeedbackWrapper = this.$form.parents(
                            ".js-form-feedback-wrap"
                        );

                        $("html, body").animate({scrollTop: $formFeedbackWrapper.offset().top - 130}, 500);

                        $formFeedbackWrapper
                            .addClass("success-form")
                            .find(".js-success-message-wrap")
                            .addClass("_active")
                            .find(".js-success-message")
                            .text("")
                            .prepend(response.message);

                        $formFeedbackWrapper
                            .find(".js-form-feedback-wrap-overlay")
                            .addClass("_active");
                    }
                    if (this.$form.closest(".js-popup").length) {
                        this.$form.closest(".js-popup").find('.popup__content').addClass("success-form");
                    }
                }

                // Автоматически закрываем сообщения
                // setTimeout(() => {
                // this.$form.removeClass('_success _error');
                // }, 5000);
            },
            error: () => {
                // Ошибка отправки

                App.H.removeClass("_form-success").addClass(
                    "_form-error _form-message"
                );

                console.log("Ошибка отправки формы");

                // Разблокируем кнопку
                this.$btn.removeAttr("disabled");

                // Автоматически закрываем сообщения
                // setTimeout(() => {
                // this.$form.removeClass('_success _error');
                // }, 5000);
            },
        });
    }

    // Закрытие формы
    bindClose() {
        App.H.find(".js-form-ok").on("click", function (e) {
            e.preventDefault();
            App.H.removeClass("_form-success _form-error _form-message");
        });
    }

    // Загрузка файла
    fileUpload() {
        this.$form.find(".js-upload").on("change", function () {
            const $input = $(this);
            const $label = $input
                .closest(".js-input-wrap")
                .find(".js-upload-label");
            const $labelContainer = $input
                .closest(".js-input-wrap")
                .find(".js-upload-label-container");
            const val = $input.val();
            let fileName;

            if (val.length) {
                fileName = val.split("\\").pop() || "";
                $label.text(fileName);
                $input.addClass("_active");
                $labelContainer.addClass("_filled");
            } else {
                $label.text($label.data("text"));
                $input.removeClass("_active");
                $labelContainer.removeClass("_filled");
            }
        });

        this.$form.find(".js-upload-clear").on("click", function () {
            $(this).siblings(".js-upload").val("").change();
        });
    }

    // Для поля телефона допускаем только цифры, пробел и +-()
    filterPhone() {
        this.$form.find("[data-phone]").on("input", function () {
            const val = $(this)
                .val()
                .replace(/[^0-9\s()+-]/g, "");
            $(this).val(val);
        });
    }

    // Сброс формы
    resetForm() {
        this.$form[0].reset();

        this.$form
            .find(".js-upload")
            .val("")
            .change()
            .siblings("[data-label]")
            .text("");

        // this.$form.removeClass('_success _error');

        this.$form
            .find("[data-required]")
            .not(":checkbox")
            .addClass("_notvalidated")
            .removeClass("_error");

        this.$form
            .find(":checkbox[data-required]")
            .not(":checked")
            .addClass("_notvalidated");

        this.$form.find(".js-submit").attr("disabled", true);

        this.$form.find(".js-input-wrap").removeClass("_focused");

        this.$form.find(".js-dropdown").trigger("dropdown:reset");

        this.$form.find(".select").closest(".js-input-wrap").addClass("_focused");
    }

    // Подсказки для инпутов
    drawPriceInInput() {
        this.$form.find(".js-price-input").each((index, el) => {
            const $currItem = $(el);
            const val = $.trim($currItem.val());

            $currItem
                .parent()
                .append(
                    `<span class="price-drawn-value">${this.formatPrice(
                        val
                    )}</span>`
                );

            if (!val.length || val == "+7() --") {
                $currItem.closest(".js-input-wrap").removeClass("_focused");
            } else {
                $currItem.closest(".js-input-wrap").addClass("_focused");
            }
        });
    }

    formatPrice(val) {
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " ₽";
    }

    popLabels() {
        this.$form.find("input.js-input, textarea.js-input, select.js-input").each(function () {
            const val = $.trim($(this).val());

            if (!val.length || val == "+7() --") {
                $(this).closest(".js-input-wrap").removeClass("_focused");
            } else {
                $(this).closest(".js-input-wrap").addClass("_focused");
            }
        });

        this.$form
            .find("input.js-input, textarea.js-input, select.js-input")
            .on("input blur", (e) => {
                const $currItem = $(e.target);
                const $currWrap = $currItem.closest(".js-input-wrap");
                const val = $.trim($currItem.val());

                if ($currItem.is(".js-price-input")) {
                    const newVal = val.replace("e", "");

                    $currWrap
                        .find(".price-drawn-value")
                        .html(this.formatPrice(newVal));
                }

                if (!val.length || val == "+7() --") {
                    $currWrap.removeClass("_focused");
                } else {
                    $currWrap.addClass("_focused");
                }
            });
    }

    // Отключаем автозаполнение полей в хроме
    disableAutoFill() {
        this.$form
            .find(
                '[type="text"], [type="email"], [type="tel"], [type="password"]'
            )
            .attr("autocomplete", "new-password");
    }

    // Фикс autocomplete="off" для IE и Edge
    disableIEautocomplete() {
        if (App.ie || App.edge) {
            window.onbeforeunload = function () {
                $('form[autocomplete="off"]').each(function () {
                    this.reset();
                });
            };
        }
    }

    // Защита от спама (если нет рекапчи)
    spamCheck() {
        App.secondsOnPage = 0;

        // Проверка phantomJS
        let isBot = function () {
            var retval = false;

            if (window._phantom || window.callPhantom) retval = true;
            if (window.__phantomas) retval = true; //PhantomJS-based web perf metrics + monitoring tool
            if (window.Buffer) retval = true; //nodejs
            if (window.emit) retval = true; //couchjs
            if (window.spawn) retval = true; //rhino
            if (window.webdriver) retval = true; //selenium
            if (window.domAutomation || window.domAutomationController)
                retval = true; //chromium based automation driver
            // if (window.outerWidth === 0 && window.outerHeight === 0) retval = true; //headless browser

            return retval;
        };

        if (isBot()) {
            return false;
        }

        // Считаем, сколько времени пользователь провёл на сайте, и отправляем это в форме
        let name = this.$form.data("name");
        this.$form.append(
            `<input type="hidden" name="${name}" class="js-input-seconds" value="0" />`
        );

        clearInterval(App.antispamTimeout);
        App.antispamTimeout = setInterval(() => {
            App.secondsOnPage++;
            this.$form.find(".js-input-seconds").val(App.secondsOnPage);
        }, 1000);
    }
}

const $forms = $(".js-form");

if ($forms.length) {
    $forms.each(function () {
        new Form(this);
    });
}

$(".js-btn-close-message").click(function (e) {
    let $el = $(this);

    $el.closest(".js-success-message-wrap").removeClass("_active");
    $el.closest(".js-form-feedback-wrap").removeClass("success-form");
    $el.closest(".js-form-feedback-wrap")
        .find(".js-form-feedback-wrap-overlay")
        .removeClass("_active");
    $el.closest(".js-form-feedback-wrap")
        .find(".js-form")
        .removeClass("_form-success _form-message");

    // если форма внутри попап, то пр нажатии на "закрыть" закрываем и сам попап.
    if ($el.closest('.js-popup').length) {
        $el.closest('.js-popup').find('.js-popup-close').trigger('click');
    }

    e.preventDefault();
});

// если есть поле промокода, то снимает валидацию, т.к. по умолчанию оно скрыто и валидировать его не нужно по условиями задачи
const $promocodeField = $('.js-promocode-field');

if ($promocodeField.length) {
    $promocodeField
        .removeClass('_focused')
        .find('.js-promocode').removeAttr('data-required');
}

/* Раскрытие поля промокода */
$('.js-promocode-btn').click(function (e) {
    const $this = $(this);
    const $thisParent = $this.parent();
    const $thisPromocodeWrap = $thisParent.siblings('.js-promocode-field');

    $thisParent.toggleClass('_clicked');
    $thisPromocodeWrap.stop().slideToggle();

    if ($thisParent.is('._clicked')) {
        $thisPromocodeWrap
            .removeClass('_focused')
            .find('.js-promocode').attr('data-required', '');
    } else {
        $thisPromocodeWrap
            .addClass('_focused')
            .find('.js-promocode').removeAttr('data-required').removeClass('_error');
    }

    e.preventDefault();
});
